import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const iconLibrary = [
  '1.webp',
  '2.webp',
  '3.webp',
  '4.webp',
  '5.webp',
  '6.webp',
  '7.webp',
  '8.webp',
  '9.webp',
  '10.webp',
  '11.webp',
  '12.webp',
];

const iconMap = Object.fromEntries(
  iconLibrary.map(filename => [filename, require(`club_product_v2/${filename}`)])
);

const AddMenuItemModal = ({ show, onHide, onSave, editMode = false, initialData = null }) => {
  const [name, setName] = useState('');
  const [iconSource, setIconSource] = useState('library'); // 'library' or 'upload'
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [uploadedIcon, setUploadedIcon] = useState(null);
  const [addType, setAddType] = useState('link'); // 'link' or 'upload'
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [uploadFileError, setUploadFileError] = useState('');
  const [uploadImageError, setUploadImageError] = useState('');

  useEffect(() => {
    if (editMode && initialData) {
      setName(initialData.name || '');
      setIconSource('library');
      setSelectedIcon(initialData.icon || null);
      setUploadedIcon(null);
      setAddType(initialData.link ? 'link' : 'upload');
      setLink(initialData.link || '');
      setFile(initialData.file || null);
    } else {
      setName('');
      setIconSource('library');
      setSelectedIcon(null);
      setUploadedIcon(null);
      setAddType('link');
      setLink('');
      setFile(null);
    }
  }, [editMode, initialData, show]);

  const handleImageUpload = (file) => {
    let message = '';

    if (file.size > 6000000) {
      message = 'File exceeds maximum size.';
    }

    if (!['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'].includes(file.type)) {
      message += ' File format should be jpg, jpeg, gif, png, bmp, webp.';
    }

    if (message !== '') {
      setUploadImageError(message);
      setUploadedIcon(null);
    } else {
      setUploadImageError('');
      setUploadedIcon(file);
    }
  }

  const handleFileUpload = (file) => {
    let message = '';

    if (file.size > 10000000) {
      message = 'File exceeds maximum size.';
    }

    // if (!['image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(file.type)) {
    //   message += ' File format should be jpg, jpeg, gif, png, bmp.';
    // }

    if (message !== '') {
      setUploadFileError(message);
      setFile(null);
    } else {
      setUploadFileError('');
      setFile(file);
    }
  }

  const handleSave = () => {
    const data = {
      id: editMode && initialData ? initialData.id : undefined,
      name,
      icon: iconSource === 'library' ? selectedIcon : null,
      uploaded_icon: iconSource === 'upload' ? uploadedIcon : null,
      addType,
      link: addType === 'link' ? link : null,
      file: addType === 'upload' ? file : null,
    };

    onSave(data);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        {editMode ? window.I18n.t('mobile_app_dashboard.modals.edit_menu_item') : window.I18n.t('mobile_app_dashboard.modals.add_new_menu_item')}
      </Modal.Header>
      <Modal.Body>
        <div className="form-row">
          <div className='row'>
            <div className='col-sm-3 col-md-3 col-lg-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.name')}</label>
            </div>
            <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        </div>

        <hr />

        <div className="form-row">
          <div className='row'>
            <div className='col-sm-3 col-md-3 col-lg-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.icon')}</label>
            </div>
            <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
              <div>
                <label className="icheck-label col-xs-12 col-sm-12 col-md-12 col-lg-12 add-margin-bottom-10">
                  <div className={`iradio_square-orange icheck-item ${iconSource === 'upload' ? 'checked' : ''}`}>
                    <input
                      className="i-checks icheck-input"
                      type="radio"
                      name="icon_source"
                      value='upload'
                      checked={iconSource === 'upload'}
                      onChange={() => setIconSource('upload')}
                    />
                  </div>
                  <span>{window.I18n.t('mobile_app_dashboard.modals.upload_icon')}</span>
                </label>

                <label className="icheck-label col-xs-12 col-sm-12 col-md-12 col-lg-12 add-margin-bottom-10">
                  <div className={`iradio_square-orange icheck-item ${iconSource === 'library' ? 'checked' : ''}`}>
                    <input
                      className="i-checks icheck-input"
                      type="radio"
                      name="icon_source"
                      value='library'
                      checked={iconSource === 'library'}
                      onChange={() => setIconSource('library')}
                    />
                  </div>
                  <span>{window.I18n.t('mobile_app_dashboard.modals.pick_icon')}</span>
                </label>
              </div>

              {iconSource === 'upload' && (
                <>
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/gif,image/bmp,image/webp"
                    className='add-padding-left-15'
                    onChange={(e) => handleImageUpload(e.target.files[0])}
                  />

                  <div className='help-message add-margin-left-20 add-margin-top-10'>
                    <div>{window.I18n.t('mobile_app_dashboard.modals.acceptable_photo')}</div>
                  </div>
                </>
              )}

              {uploadImageError && (
                <div className='error-message btsp_alert_notices add-margin-bottom-10 add-padding-all-5'>
                  {uploadImageError}
                </div>
              )}

              {iconSource === 'library' && (
                <div className="icon-library container">
                  {iconLibrary.map((filename, idx) => (
                    <div
                      key={idx}
                      className={`col-xs-3 col-sm-3 col-md-3 col-lg-3 icon-container`}
                      onClick={() => setSelectedIcon(filename)}
                    >
                      <div
                        className='icon-wrapper'
                        style={{
                          border: selectedIcon === filename ? '2px solid #FF6633' : '2px solid transparent',
                        }}
                      >
                        <img
                          src={iconMap[filename]}
                          alt={filename}
                        />
                      </div>
                      <div className={`${selectedIcon === filename ? 'selected-text' : 'select-text'}`}>
                        {selectedIcon === filename ?
                          window.I18n.t('mobile_app_dashboard.modals.selected')
                          : window.I18n.t('mobile_app_dashboard.modals.select')
                        }
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <hr />

        <div className="form-row">
          <div className='row'>
            <div className='col-sm-3 col-md-3 col-lg-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.add')}</label>
            </div>
            <div className='col-xs-12 col-sm-9 col-md-9 col-lg-9'>
              <div>
                <div className='row add-margin-bottom-5 link-row'>
                  <label className="icheck-label col-xs-3 col-sm-3 col-md-3 col-lg-3 link-label">
                    <div className={`iradio_square-orange icheck-item ${addType === 'link' ? 'checked' : ''}`} style={{ alignItems: 'baseline', display: 'flex' }}>
                      <input
                        className="i-checks icheck-input"
                        type="radio"
                        name="add_type"
                        value='link'
                        checked={addType === 'link'}
                        onChange={() => setAddType('link')}
                      />
                    </div>
                    <span>{window.I18n.t('mobile_app_dashboard.modals.link')}</span>
                  </label>

                  <div className='col-xs-9 col-sm-9 col-md-9 col-lg-9'>
                    {addType === 'link' && (
                      <input
                        type="text"
                        name='add_link_text'
                        className="form-control"
                        placeholder="Enter link"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                      />
                    )}
                  </div>
                </div>

                <div className='row link-row add-margin-bottom-10'>
                  <label className="icheck-label link-label">
                    <div className={`iradio_square-orange icheck-item ${addType === 'upload' ? 'checked' : ''}`}>
                      <input
                        className="i-checks icheck-input"
                        type="radio"
                        name="add_type"
                        value='upload'
                        checked={addType === 'upload'}
                        onChange={() => setAddType('upload')}
                      />
                    </div>
                    <span>{window.I18n.t('mobile_app_dashboard.modals.upload_file')}</span>
                  </label>
                </div>
                <div className='row'>
                  {addType === 'upload' && (
                    <>
                      <input
                        type="file"
                        className='add-padding-left-25'
                        onChange={(e) => handleFileUpload(e.target.files[0])}
                      />

                      <div className='help-message add-margin-left-20 add-margin-top-10'>
                        <div>{window.I18n.t('mobile_app_dashboard.modals.acceptable_file')}</div>
                      </div>
                    </>
                  )}
                  {uploadFileError && (
                    <div className='error-message btsp_alert_notices add-margin-bottom-10 add-padding-all-5'>
                      {uploadFileError}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button
          className="btsp_orange_button"
          onClick={handleSave}
          disabled={!name}
        >
          {window.I18n.t('mobile_app_dashboard.modals.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMenuItemModal;
